import { APP_TYPE_PROSPECT, APP_TYPE_WIJZIGEN } from '@/constants';
import UserService from '@/services/UserService';

const createStore = app => {
    const state = {
        relatienummer: null,
        klantSessieNietActief: false,
        isVerzekeringnemerIngelogd: false,
        hasReadOnlyRole: false,
        error: false
    };

    const getters = {
        getRelatienummer: state => state.relatienummer,
        getKlantSessieNietActief: state => state.klantSessieNietActief,
        getIsVerzekeringnemerIngelogd: state => state.isVerzekeringnemerIngelogd,
        getHasReadOnlyRole: state => state.hasReadOnlyRole,
        getErrorStatus: state => state.error
    };

    const actions = {
        setRelatienummer: ({ getters, commit, dispatch, rootGetters }, relatienummer) => {
            // check afwijkende relatie
            if (relatienummer !== getters.getRelatienummer) {
                // clear pakketten en users indien ander relatienummer
                dispatch('pakketten/clear', null, { root: true });
                dispatch('users/clear', null, { root: true });

                // opslaan nieuw relatienummer
                commit('SET_RELATIENUMMER', relatienummer);

                // ophalen nieuwe pakketten indien nodig
                switch (rootGetters['renderInfo/getAppType']) {
                    case APP_TYPE_PROSPECT:
                    case APP_TYPE_WIJZIGEN:
                        dispatch('pakketten/ophalen', null, { root: true });
                        break;
                }
            }
        },
        setKlantSessieNietActief: ({ commit }, klantSessieNietActief) => {
            commit('SET_KLANT_SESSIE_NIET_ACTIEF', klantSessieNietActief);
        },
        setIsVerzekeringnemerIngelogd: ({ commit }, isVznIngelogd) => {
            commit('SET_IS_VZN_INGELOGD', isVznIngelogd);
        },
        setHasReadOnlyRole: ({ commit }, hasReadOnlyRole) => {
            commit('SET_HAS_READ_ONLY_ROLE', hasReadOnlyRole);
        },
        setErrorStatus: ({ commit }, error) => {
            commit('SET_ERROR_STATUS', error);
        },
        async ophalenLoginInfo({ dispatch }) {
            const appContext = app.config.globalProperties.$jss.appContext();

            // Login informatie hoeft niet te worden opgehaald in de prospect flow
            if (appContext?.appType === APP_TYPE_PROSPECT) return;

            dispatch('setPendingStatus', true, { root: true });
            dispatch('setErrorStatus', false);

            try {
                // ophalen login info
                const loginInfo = await UserService.getLoginInfo();

                dispatch('setKlantSessieNietActief', loginInfo.loginAlsKlantSessieNietActief);
                dispatch('setIsVerzekeringnemerIngelogd', loginInfo.isVerzekeringnemerIngelogd);
                dispatch('setRelatienummer', loginInfo.relatienummer);
                dispatch('setHasReadOnlyRole', loginInfo.hasReadOnlyRole);
            } catch (error) {
                console.log('Kan geen logininfo ophalen:', error.message);
                dispatch('setErrorStatus', true);
            } finally {
                dispatch('setPendingStatus', false, { root: true });
            }
        }
    };

    const mutations = {
        SET_RELATIENUMMER: (state, relatienummer) => {
            state.relatienummer = relatienummer;
        },
        SET_KLANT_SESSIE_NIET_ACTIEF: (state, klantSessieNietActief) => {
            state.klantSessieNietActief = klantSessieNietActief;
        },
        SET_IS_VZN_INGELOGD: (state, isVznIngelogd) => {
            state.isVerzekeringnemerIngelogd = isVznIngelogd;
        },
        SET_ERROR_STATUS: (state, error) => {
            state.error = error;
        },
        SET_HAS_READ_ONLY_ROLE: (state, hasReadOnlyRole) => {
            state.hasReadOnlyRole = hasReadOnlyRole;
        }
    };

    return {
        namespaced: true,
        state,
        getters,
        actions,
        mutations
    };
};

export const loginStoragePaths = ['login.relatienummer', 'login.isVerzekeringnemerIngelogd'];

export default app => createStore(app);
